// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"iY-z","sponsoredTooltipWrapper":"jY-z","sponsoredTooltip":"kY-z","newCard":"lY-z"};